// SDS public-site JS entrypoint.
import { initHomepageIntroRotators } from "./components/homepage-intro";
import { initLightbox } from "./components/lightbox";
import { openLeavingLinksInNewTab } from "./components/new-tab-links";
import { initSeasonNews } from "./components/season-news";
import { initVideoTiles } from "./components/video-tiles";

document.addEventListener("DOMContentLoaded", () => {
  initHomepageIntroRotators();
  openLeavingLinksInNewTab();
  initLightbox();
  initSeasonNews();
  initVideoTiles();
});
